<template>
  <div class="login">
    <div class="loginBox">
      <div class="loginBoxNew">

        <!-- 扫码登录 -->
        <div class="codeLogin" v-show="loginType === 'weChat'">
          <div class="codeLoginTItle">手机扫码&nbsp;安全登录</div>
          <div class="phoneLogin">
            <!-- 切换端 -->
            <div class="clearfix port">
              <div class="portBox fl" :class="port === 'teacher'?'portActive':'portNoActive'" @click="changePort('teacher')">我要找工作</div>
              <div class="portBox fr" :class="port === 'teacher'?'portNoActive':'portActive'" @click="changePort('boss')">我要招幼师</div>
            </div>
            <div class="weChatCode">
              <img :src="weChatCode" alt="">
            </div>
          </div>
        </div>

        <!-- 验证码登录 -->
        <div class v-show="loginType === 'phone'">
          <div class="codeLoginTItle">验证码登录</div>
          <div class="phoneLogin">
            <!-- 切换端 -->
            <div class="clearfix port">
              <div class="portBox fl" :class="port === 'teacher'?'portActive':'portNoActive'" @click="changePort('teacher')">我要找工作</div>
              <div class="portBox fr" :class="port === 'teacher'?'portNoActive':'portActive'" @click="changePort('boss')">我要招幼师</div>
            </div>
            <el-form ref="form" :model="loginForm" :rules="loginRule">
              <el-form-item prop="phone">
                <el-input prefix-icon="el-icon-mobile-phone" v-model.number="loginForm.phone" placeholder="请输入手机号" />
              </el-form-item>
              <el-form-item prop="code">
                  <div class="shortMessageTextBox">
                        <el-input prefix-icon="el-icon-message" v-model.number="loginForm.code" placeholder="请输入短信验证码" />
                        <el-button v-show="shortShow" type="text" class="shortMessageText" @click="getShortMessage"><el-divider direction="vertical"></el-divider>获取验证码</el-button>
                        <el-button disabled v-show="!shortShow" type="text" class="shortMessageText"><el-divider direction="vertical"></el-divider>{{count}}s后获取</el-button>
                  </div>
              </el-form-item>
            </el-form>
          </div>
          <div class="loginBtn" @click="loginPhone">登录</div>
        </div>

        <!-- 切换登录方式 -->
        <div class="changeLogin">
          <div class="phoneLoginBtn" v-if="loginType === 'weChat'" @click="changeLogin">验证码登录</div>
          <div class="weChatLoginBtn" v-if="loginType === 'phone'" @click="changeLogin">微信登录</div>
          <!-- <el-link class="fr">免费注册</el-link> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getWeChatCode } from '@/js/common.js'
import { showAliyunCaptcha } from '@/js/aliyunCaptcha'
export default {
  data() {
    return {
      code: "",
      Wechat_authorized_login: false,
      loginType: "phone",
      loginForm: {},
      shortShow: true,
      count: '',
      timer: null,
      loginRule: {
        phone: [
          { required: true, message: '手机号不能为空'},
          { type: 'number', message: '手机号必须为数字'}
        ],
        code: [
          { required: true, message: '验证码不能为空'},
          { type: 'number', message: '验证码必须为数字'}
        ]
      },
      port: 'teacher',
      weChatCode: ''
    };
  },
  watch: {
    $route() {
      if (this.$route.query.code) {
        this.code = this.$route.query.code;
      }
      if (this.$route.query.state) {
        this.state = this.$route.query.state;
      }
    },
    code() {
      this.getAccToken();
    }
  },
  mounted() {
    
  },
  methods: {
    // 切换端
    changePort(port) {
      this.port = port
    },

    // 获取acctoken
    getAccToken() {
      this.$axios({
        method: "post",
        dataType: "jsonp",
        url: "https://api.weixin.qq.com/sns/oauth2/access_token?appid=wx8ff0fb39dc4de168&secret=64aef4be84247a83fbe1a2007340dc2c&code=" + this.code + "&grant_type=authorization_code"
      })
    },

    // 登录方式改变
    changeLogin() {
      this.api.post('/628df7884f2e8', {}).then(r => {
        this.login_id = r.data.login_id
        getWeChatCode(this, 'pcLogin/pages/index/index', r.data.login_id)
      })
      this.loginType = this.loginType === "weChat" ? "phone" : "weChat";
      if(this.loginType === 'weChat') {
        this.getLoginType()
      }
    },

    // 判断微信是否授权登录
    getLoginType() {
      let timer = setInterval(() => {
        this.api.post('/628df7cecea3b', { login_id: this.login_id }).then(r => {
          this.Cookies.set('UserToken', r.data.user_token, { expires: 1 })
          this.Cookies.set('school_user_token', r.data.school_user_token, { expires: 1 })
          this.Cookies.set('schoolUser', JSON.stringify(r.data.schoolUser), { expires: 1 })
          this.Cookies.set('schoolInfo', JSON.stringify(r.data.schoolInfo), { expires: 1 })
          this.Cookies.set('members', JSON.stringify(r.data.members), { expires: 1 })
          let bindObj = {
            is_bind_mobile: r.data.is_bind_mobile,
            is_bind_wechat: 1
          }
          sessionStorage.setItem('bind', JSON.stringify(bindObj))
          if(this.port === 'boss') {
            sessionStorage.setItem('port','boss')
            sessionStorage.setItem('navBar', JSON.stringify(this.$router.options.routes.filter(o=>!o.hide && o.port === 'boss')))
            if(r.data.schoolInfo) {
              this.$router.push({
                path: '/boss/resume'
              })
              this.$message({
                message: '登录成功',
                type: 'success'
              });
            } else {
              this.$router.push({
                path: '/boss/addSchool'
              })
              this.$message({
                message: '登录成功，您还没有园所，请先创建园所',
                type: 'success'
              });
            }
          } else {
            this.$router.push({
                path: '/'
            })
            sessionStorage.setItem('port','teacher')
            sessionStorage.setItem('navBar', JSON.stringify(this.$router.options.routes.filter(o=>!o.hide && o.port === 'teacher')))
            this.$message({
              message: '登录成功',
              type: 'success'
            });
          }
          clearInterval(timer);
        })
      }, 5000)
    },

    // 获取短信验证码
    getShortMessage() {
      if (!this.loginForm.phone) {
        this.$message.error('请输入手机号')
        return
      }

      showAliyunCaptcha().then((captchaResult) => {
        const obj = {
          mobile: JSON.stringify(this.loginForm.phone),
          device_id: JSON.parse(this.Cookies.get('DeviceId')).device_id,
          lot_number: captchaResult.lot_number,
          captcha_output: captchaResult.captcha_output,
          pass_token: captchaResult.pass_token,
          gen_time: captchaResult.gen_time
        }
        return this.api.post('/5cdb64c7ebcba', obj)
      }).then((r) => {
        if (!r) return
        const timeCount = 60
        if (!this.timer) {
          this.count = timeCount
          this.shortShow = false
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= timeCount) {
              this.count--
            } else {
              this.shortShow = true
              clearInterval(this.timer)
              this.timer = null
            }
          }, 1000)
        }
      }).catch((err) => {
        if (err && err.message === 'CAPTCHA_CANCEL') return
        if (err && err.message) {
          this.$message.error(err.message)
        }
      })
    },

    // 手机登录
    loginPhone() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          //   调用接口
          let obj = {
              code: JSON.stringify(this.loginForm.code),
              device_id: JSON.parse(this.Cookies.get('DeviceId')).device_id,
              loginMethod: "loginByMobileAdSmscode",
              mobile: this.loginForm.phone
          }
          this.api.post('/5cdb654e52421', obj).then(r => {
              this.Cookies.set('UserToken', r.data.user_token, { expires: 1 })
              this.Cookies.set('school_user_token', r.data.school_user_token, { expires: 1 })
              this.Cookies.set('schoolUser', JSON.stringify(r.data.schoolUser), { expires: 1 })
              this.Cookies.set('schoolInfo', JSON.stringify(r.data.schoolInfo), { expires: 1 })
              this.Cookies.set('members', JSON.stringify(r.data.members), { expires: 1 })
              let bindObj = {
                is_bind_mobile: 1,
                is_bind_wechat: r.data.is_bind_wechat
              }
              sessionStorage.setItem('bind', JSON.stringify(bindObj))
              if(this.port === 'boss') {
                  sessionStorage.setItem('port','boss')
                  sessionStorage.setItem('navBar', JSON.stringify(this.$router.options.routes.filter(o=>!o.hide && o.port === 'boss')))
                  if(r.data.schoolInfo) {
                    this.$router.push({
                      path: '/boss/resume'
                    })
                    this.$message({
                      message: '登录成功',
                      type: 'success'
                    });
                  } else {
                    this.$router.push({
                      path: '/boss/addSchool'
                    })
                    this.$message({
                      message: '登录成功，您还没有园所，请先创建园所',
                      type: 'success'
                    });
                  }
              } else {
                this.$router.push({
                    path: '/'
                })
                sessionStorage.setItem('port','teacher')
                sessionStorage.setItem('navBar', JSON.stringify(this.$router.options.routes.filter(o=>!o.hide && o.port === 'teacher')))
                this.$message({
                  message: '登录成功',
                  type: 'success'
                });
              }

              // websocket登录
              
          })
        } else {
          return false;
        }
      });
    },
  }
};
</script>

<style lang="scss" scoped>
.login {
  background: url(../assets/loginBanner.png) center bottom no-repeat;
  height: 100vh;
  position: relative;
  .loginBox {
      position: absolute;
    right: 6%;
    top: 20%;
    width: 30%;
    .loginBoxNew {
      background: white;
      border-radius: 10px;
      min-height: 500px;
      .port {
        padding-bottom: 20px;
        .portBox {
          width: 47%;
          height: 36px;
          line-height: 36px;
          text-align: center;
          font-size: 14px;
          cursor: pointer;
        }
        .portNoActive {
          border: 1px #e3e7ed solid;
        }
        .portActive {
          border: 1px #ff5b12 solid;
          color: #ff5b12;
        }
      }
      .wx_dialog_toiast_delltet {
        text-align: center;
        height: 345px;
        overflow: hidden;
      }
      .codeLoginTItle {
        text-align: center;
        padding-top: 68px;
        font-size: 20px;
      }
      .phoneLogin {
        padding-top: 47px;
        width: 70%;
        margin: 0 auto;
      }
      .loginBtn {
          width: 70%;
          margin: 0 auto;
          text-align: center;
          color: white;
          background: #ff5b12;
          border-radius: 4px;
          padding: 10px 0;
          margin-bottom: 20px;
          cursor: pointer;
          transition: opacity .3s;
      }
      .loginBtn:hover {
          opacity: .8;
      }
    }
    .changeLogin {
      width: 70%;
      margin: 0 auto;
      padding-bottom: 68px;
    }
  }
}
.shortMessageTextBox {
    position: relative;
    .shortMessageText {
        position: absolute;
        right: 15px;
        top: 0;
    }
}

.weChatCode {
  text-align: center;
  img {
    width: 45%;
  }
}

.weChatLoginBtn {
  background: rgba(42, 165, 21, 1);
  color: white;
  text-align: center;
  border-radius: 4px;
  padding: 10px 0;
  cursor: pointer;
  transition: opacity .3s;
}
.weChatLoginBtn:hover {
  opacity: .8;
}
.phoneLoginBtn {
  background: #ff5b12;
  color: white;
  text-align: center;
  border-radius: 4px;
  padding: 10px 0;
  cursor: pointer;
  transition: opacity .3s;
}
.phoneLoginBtn:hover {
  opacity: .8;
}
</style>


// WEBPACK FOOTER //
// src/pages/login.vue